import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Activity, Shield, Router, History as HistoryIcon, ArrowLeft } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

const ScriptsGeneratorPage = () => {
  const navigate = useNavigate();
  const { isDark } = useTheme();

  const modules = [
    {
      id: 'balanceador',
      title: 'Balanceador',
      description: 'Configuración de balanceo de carga NTH o PCC',
      icon: Activity,
      color: isDark 
        ? 'from-blue-900/30 to-blue-800/30 border-blue-700 hover:border-blue-500'
        : 'from-blue-500 to-blue-600 hover:shadow-2xl',
      iconBg: 'from-blue-500 to-blue-600',
      path: '/scripts/balanceador'
    },
    {
      id: 'hotspot',
      title: 'Hotspot',
      description: 'Configuración de hotspot con credenciales admin',
      icon: Router,
      color: isDark
        ? 'from-purple-900/30 to-purple-800/30 border-purple-700 hover:border-purple-500'
        : 'from-purple-500 to-purple-600 hover:shadow-2xl',
      iconBg: 'from-purple-500 to-purple-600',
      path: '/scripts/hotspot'
    },
    {
      id: 'failover',
      title: 'Failover',
      description: 'Configuración de failover con WANs de respaldo',
      icon: Shield,
      color: isDark
        ? 'from-red-900/30 to-red-800/30 border-red-700 hover:border-red-500'
        : 'from-red-500 to-red-600 hover:shadow-2xl',
      iconBg: 'from-red-500 to-red-600',
      path: '/scripts/failover'
    }
  ];

  return (
    <div className={`min-h-screen ${isDark ? 'bg-gray-900 text-white' : 'bg-gradient-to-br from-gray-50 to-gray-100 text-gray-900'}`}>
      <div className="container mx-auto px-4 py-16">
        {/* Header con botón volver */}
        <div className="flex items-center gap-4 mb-8">
          <button
            onClick={() => navigate('/dashboard')}
            className={`p-2 rounded-lg ${isDark ? 'hover:bg-gray-800' : 'hover:bg-gray-200'}`}
          >
            <ArrowLeft size={24} />
          </button>
        </div>

        <div className="text-center mb-16">
          <h1 className={`text-5xl font-bold mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`}>
            Generador de Scripts MikroTik
          </h1>
          <p className={`text-xl ${isDark ? 'text-gray-300' : 'text-gray-600'}`}>
            Genera configuraciones RouterOS personalizadas
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto mb-8">
          {modules.map((module) => {
            const Icon = module.icon;
            return (
              <button
                key={module.id}
                onClick={() => navigate(module.path)}
                className={`group p-6 rounded-2xl transition-all duration-300 ${
                  isDark 
                    ? `border-2 backdrop-blur-sm ${module.color}` 
                    : `bg-gradient-to-br ${module.color}`
                } hover:scale-105 cursor-pointer`}
              >
                <div className="flex flex-col items-center text-center space-y-4">
                  <div className={`p-4 rounded-full bg-gradient-to-br ${module.iconBg} shadow-lg`}>
                    <Icon className="w-12 h-12 text-white" />
                  </div>
                  <div>
                    <h3 className={`text-2xl font-bold mb-2 ${isDark ? 'text-white' : 'text-white'}`}>
                      {module.title}
                    </h3>
                    <p className={`text-sm ${isDark ? 'text-gray-300' : 'text-white/90'}`}>
                      {module.description}
                    </p>
                  </div>
                </div>
              </button>
            );
          })}
        </div>

        <div className="text-center">
          <button
            onClick={() => navigate('/scripts/history')}
            className={`inline-flex items-center gap-2 px-6 py-3 rounded-lg transition-colors ${
              isDark 
                ? 'bg-gray-700 hover:bg-gray-600 text-white' 
                : 'bg-gray-700 hover:bg-gray-600 text-white'
            }`}
          >
            <HistoryIcon className="w-5 h-5" />
            Ver Historial de Scripts
          </button>
        </div>
      </div>
    </div>
  );
};

export default ScriptsGeneratorPage;
